import RequestInterceptor from './interceptors';

class EncryptionSDK {
  constructor() {
    this.init();
  }

  init() {
    new RequestInterceptor();
  }
}

export default EncryptionSDK;
